/** Shared area-page campaign config (NHK). Update URLs/images in one place when the campaign changes. */
export const NHK_AREA_PAGE_BANNER_CONFIG = {
  bannerUrl: {
    pc: 'https://www3.nhk.or.jp/nhkworld/en/live_tv/?cid=wohk-Live-link_site_keikyu-ecbo-pc-202604-003',
    sp: 'https://www3.nhk.or.jp/nhkworld/en/live_tv/?cid=wohk-Live-link_site_keikyu-ecbo-pc-202604-004',
  },
  bannerImage: {
    pc: '/ads/nhk_pc.jpg',
    sp: '/ads/nhk_sp.jpg',
  },
} as const
